import React from "react";
import PropTypes from "prop-types";
import { Divider, Box } from "@mui/material";
import { DrawerHeader } from "../../Main.Layout";
import SidebarHeader from "./SidebarHeader";
import SidebarMenu from "./SidebarMenu";
import SidebarFooter from "./SidebarFooter";

const Sidebar = ({
  open,
  drawerWidth,
  handleDrawerToggle,
  selectedMenu,
  selectedSubmenu,
  expandedMenu,
  handleToggleMenu,
  handleSubmenuClick,
  handleLogout,
  handleNavigateToTaxes,
  user,
  isLoading,
  Menus,
  theme,
  DrawerStyled,
  setOpenProfile,
  isMobile = false,
  marketplacePlans = [],
  userData = null,
}) => {
  const DrawerComponent = isMobile ? Box : DrawerStyled;
  
  return (
    <DrawerComponent variant={isMobile ? undefined : "permanent"} open={isMobile ? true : open}>
      {!isMobile && (
        <DrawerHeader>
          <SidebarHeader
            open={open}
            drawerWidth={drawerWidth}
            handleDrawerToggle={handleDrawerToggle}
            theme={theme}
          />
        </DrawerHeader>
      )}

      {!isMobile && (
        <Divider 
          sx={{ 
            margin: "8px 16px 16px 16px", 
            borderColor: "rgba(255, 112, 67, 0.15)",
            background: "linear-gradient(90deg, transparent 0%, rgba(255, 112, 67, 0.2) 50%, transparent 100%)",
            height: "1px",
            border: "none",
          }} 
        />
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: isMobile ? "100%" : "calc(100% - 64px)",
          justifyContent: "space-between",
          minHeight: isMobile ? "calc(100vh - 140px)" : undefined, // Garantir altura mínima no mobile
        }}
      >
        <SidebarMenu
          open={isMobile ? true : open}
          Menus={Menus}
          selectedMenu={selectedMenu}
          selectedSubmenu={selectedSubmenu}
          expandedMenu={expandedMenu}
          handleToggleMenu={handleToggleMenu}
          handleSubmenuClick={handleSubmenuClick}
          theme={theme}
          marketplacePlans={marketplacePlans}
          userData={userData}
        />

        <SidebarFooter
          open={isMobile ? true : open}
          selectedMenu={selectedMenu}
          selectedSubmenu={selectedSubmenu}
          handleLogout={handleLogout}
          handleNavigateToTaxes={handleNavigateToTaxes}
          user={user}
          isLoading={isLoading}
          theme={theme}
          setOpenProfile={setOpenProfile}
        />
      </Box>
    </DrawerComponent>
  );
};

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  selectedMenu: PropTypes.number.isRequired,
  selectedSubmenu: PropTypes.number,
  expandedMenu: PropTypes.number,
  handleToggleMenu: PropTypes.func.isRequired,
  handleSubmenuClick: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  handleNavigateToTaxes: PropTypes.func.isRequired,
  user: PropTypes.object,
  isLoading: PropTypes.bool,
  Menus: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired,
  DrawerStyled: PropTypes.elementType.isRequired,
  setOpenProfile: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  marketplacePlans: PropTypes.array,
  userData: PropTypes.object,
};

export default Sidebar;
